var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "list-supplier-item ",
      staticStyle: { "list-style-type": "none" },
    },
    [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("div", [
          _c("img", {
            staticClass: "round",
            attrs: {
              src:
                _vm.member.avatar !== null
                  ? _vm.member.avatar.url
                  : "/images/avatar.png",
              alt: "avatar",
              height: "25",
              width: "25",
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("span", { staticClass: "font-weight-bold ml-05 mb-0 mt-1" }, [
              _vm._v(
                _vm._s(_vm.member.first_name) +
                  " " +
                  _vm._s(_vm.member.last_name)
              ),
            ]),
            _vm._v(" "),
            _vm._l(_vm.member.badges, function (badge) {
              return _c("span", [
                _c("img", {
                  staticStyle: { "margin-top": "-3px", height: "12px" },
                  attrs: {
                    src: badge.image,
                    "data-toggle": "tooltip",
                    "data-placement": "bottom",
                    title: badge.name,
                    alt: "badge image",
                  },
                }),
              ])
            }),
            _vm._v(" "),
            _vm.member.user_badge_name !== null &&
            _vm.member.user_badge_icon !== null
              ? _c("img", {
                  staticStyle: { "margin-top": "-3px", height: "12px" },
                  attrs: {
                    src: _vm.member.user_badge_image.url,
                    "data-toggle": "tooltip",
                    "data-placement": "bottom",
                    title: _vm.member.user_badge_name,
                    alt: "badge image",
                  },
                })
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ml-auto" }, [
          _c("div", { staticClass: "d-flex" }, [
            _c("div", { staticClass: "pr-05" }, [
              _c(
                "span",
                {
                  staticClass: "float-right d-flex mt-05",
                  attrs: { id: "group_actions_" + _vm.member.id },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "btn-sm btn-success mr-05",
                      staticStyle: { color: "#fff", border: "none" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.acceptRequest()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.__("globals.accept")) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn-sm btn-danger",
                      staticStyle: { color: "#fff", border: "none" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.declineRequest()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.__("globals.decline")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }